import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import { SVGStyled } from '../shared';

/**
 * Base SVG "Stroke" component
 *
 * @param props.as defaults to "path"; any valid SVG child element can be used.
 * @param props.lineWidth defines thickness of stroke
 * @param props.svgColor stroke color (if not set, relies on value from context)
 */
var SVGStroke = SVGStyled.path(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fill: none;\n  stroke: ", ";\n  ", "\n"])), function (_ref) {
  var svgColor = _ref.svgColor,
      theme = _ref.theme;
  return svgColor || theme.svgColor;
}, function (_ref2) {
  var lineWidth = _ref2.lineWidth;
  return lineWidth ? "stroke-width: ".concat(lineWidth, ";") : '';
});
SVGStroke.defaultProps = {
  role: 'presentation'
};
export default SVGStroke;